import { render, staticRenderFns } from "./PessoaInputV2.vue?vue&type=template&id=7520ecc5"
import script from "./PessoaInputV2.vue?vue&type=script&lang=js"
export * from "./PessoaInputV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports